import * as Yup from 'yup';

export const silicoPredictionToolEditValidationSchema = Yup.object().shape({
  score: Yup.string()
    .nullable()
    .test(
      'is-valid-score-format',
      'Score must be a valid number (e.g. 0.87, 3.063, 101)',
      (value) => {
        if (!value || value.trim() === '') {
          return true;
        }
        const trimmed = value.trim();
        return !isNaN(Number(trimmed)) && trimmed !== '';
      },
    ),
  prediction_result: Yup.string().nullable(),
  comment: Yup.mixed().nullable(),
});
